// Firebase support removed.
// This file provides a minimal no-op shim so existing imports remain valid.
// If you want to re-enable Firebase later, restore the original implementation.

const initFirebaseBackend = (config) => {
    // No-op: Firebase has been removed from this project.
    // Keep this function to avoid breaking imports in `src/main.js` and elsewhere.
    // If any call depends on a returned object, it will receive `null`.
    // Log a warning once in development to surface the change.
    if (process && process.env && process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('initFirebaseBackend called but Firebase has been removed.');
    }
    return null;
};

const getFirebaseBackend = () => {
    return null;
};

export { initFirebaseBackend, getFirebaseBackend };